
import { useContext } from "react";
import { MovieContext } from "@/context/movie/MovieContext";
import { MovieContextType } from "@/context/movie/movieContextTypes";

// This hook provides type-safe access to the MovieContext
export const useMovieContext = (): MovieContextType => {
  const context = useContext(MovieContext);
  
  if (context === undefined) {
    throw new Error("useMovieContext must be used within a MovieProvider");
  }
  
  return context;
};
